import { WebpageTreeNode } from './types';

/**
 * The path shown in a row's tooltip: the URL path only (starts with "/"), with
 * scheme/host/port stripped. Pages use their URL's pathname (+ query/hash);
 * folders use their cumulative segment path.
 */
export function getRowPath(node: WebpageTreeNode): string {
  if (node.webpage) {
    try {
      const url = new URL(node.webpage.url);
      return `${url.pathname}${url.search}${url.hash}`;
    } catch {
      return node.webpage.url;
    }
  }
  return node.path ? `/${node.path}` : '/';
}
